<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">

      <!-- 电子面单（中通模板1） -->
      <el-dialog title="中通打印电子面单" :visible.sync="printDialog" width="35%" top="10vh">
          <div style="text-align:right;margin-bottom:20px;">
              <el-button type="" size="small" round  @click="printDialog=false" >取 消</el-button>
              <el-button type="primary" size="small" round  @click="sureprint" >确 认</el-button>
          </div>
          <div id="printContent">
              <div v-for="(item,index) in printmodels" :key="index" class="printcontentmodel">
              <div class="print-express-main-ZTO" :style="'height:'+printheight+'mm;width:calc( 100% - '+printpadding+'px );' ">
                    <div class="express-ZTO-time" :style="'margin-top:'+printmargintop+'px' ">{{item.time}}</div>
                    <div class="express-ZTO-area-code">{{item.MarkDestination}}</div>
                    <div class="express-ZTO-img">
                        <img :id="item.id" />
                    </div>
                    <div class="express-ZTO-area">
                        <!--
                        <div class="express-ZTO-area-left" style="width:30%;">
                            <span>区域件</span>
                        </div>
                        -->
                        <div class="express-ZTO-area-left" style="width:calc(100% - 1px);border-right:0;text-align:left;">
                            <span>{{item.DestinatioCode}}</span>
                        </div>
                    </div>
                    <div class="express-ZTO-sender">
                        <div class="express-ZTO-sender-left">
                            <span>收</span>
                        </div>
                        <div class="express-ZTO-sender-right">
                            <div class="express-ZTO-sender-right-content">{{item.recievename}} {{item.recievephone}}</div>
                            <div class="express-ZTO-sender-right-content">{{item.recieveProvincename}}{{item.recieveCityname}}{{item.recieveArea}} {{item.recieveAddress}}</div>
                        </div>
                    </div>

                    <div class="express-ZTO-reciever">
                        <div class="express-ZTO-reciever-left">
                            <span>寄</span>
                        </div>
                        <div class="express-ZTO-reciever-right">
                            <div class="express-ZTO-reciever-right-content">{{item.sendname}} {{item.sendphone}}</div>
                            <div class="express-ZTO-reciever-right-content">{{item.sendAddress}}</div>
                        </div>
                    </div>

                    <div class="express-ZTO-bottom">
                        <div class="express-ZTO-bottom-left">
                            <span>{{item.OriginCode}}</span>
                        </div>
                        <div class="express-ZTO-bottom-right">
                            <img :id="'mini_'+item.id" />
                        </div>
                    </div>
                    <div class="express-ZTO-sell" v-if="item.goods.length==0">
                        {{item.selldocuments}}
                    </div>
                    <div v-if="item.goods.length > 0" style="border-top:1px solid #000000;float:left;width:100%;text-align:left">
                        <div style="font-size:10px;line-height:10px;transform:scale(1);transform-origin: 0 0;float:left;width:100%;" v-for="(tt,ii) in item.goods">{{tt}}</div>
                    </div>
                    
              </div>  
              </div>
          </div>
          <div style="text-align:right;margin-top:20px;">
              <el-button type="" size="small" round  @click="printDialog=false" >取 消</el-button>
              <el-button type="primary" size="small" round  @click="sureprint" >确 认</el-button>
          </div>
      </el-dialog>


      

  </div>
  </transition>
</template>

<script>
import QRCode from 'qrcodejs2'
export default {
  props:['value','data'],
  components: {QRCode},
  data () {
    return {
        printmodels:[],
        printDialog:false,
        printDialog123:false,
        printheight:this.$cookies.get("printsetheight") > 0 ? this.$cookies.get("printsetheight") : 105,
        printmargintop:this.$cookies.get("printsetmargintop") > 0 ? this.$cookies.get("printsetmargintop") : 0,
        printpadding:this.$cookies.get("printpadding") > 0 ? this.$cookies.get("printpadding") : 0,
    }  
  },

  watch: {
      value(val) {
          if (val) {
             this.printDialog=true;
             this.printlogistics();
          }
      },

  },
  
  methods:{

      //打印电子面单
      printlogistics() {
          this.printmodels=this.data;

          //生成条形码
          var JsBarcode = require('jsbarcode'); //条形码
          var _this=this;
          var content='';
          var mincontent='';
          var infos='';

          setTimeout(function() {
              for(var i=0;i < _this.printmodels.length;i++) {
                  infos=_this.printmodels[i];             
                  content="";
                  mincontent='';
                  content=infos.code;
                  mincontent="mini_"+infos.id;
                  
                  JsBarcode(document.getElementById(infos.id),content, { //生成主要条形码
                      format: "CODE128",//选择要使用的条形码类型
                      width:5,//设置条之间的宽度
                      height:150,//高度
                      displayValue:true,//是否在条形码下方显示文字
                      text:''+content+'',//覆盖显示的文本
                      fontOptions:"",//使文字加粗体或变斜体
                      font:"fantasy",//设置文本的字体
                      textAlign:"center",//设置文本的水平对齐方式
                      textPosition:"bottom",//设置文本的垂直位置
                      textMargin:5,//设置条形码和文本之间的间距
                      fontSize:45,//设置文本的大小
                      background:"#fff",//设置条形码的背景
                      lineColor:"#000",//设置条和文本的颜色。
                      margin:10//设置条形码周围的空白边距
                  });

                  JsBarcode(document.getElementById(mincontent),content, { //生成右下角小条形码
                      format: "CODE128",//选择要使用的条形码类型
                      width:5,//设置条之间的宽度
                      height:110,//高度
                      displayValue:true,//是否在条形码下方显示文字
                      text:''+content+'',//覆盖显示的文本
                      fontOptions:"",//使文字加粗体或变斜体
                      font:"fantasy",//设置文本的字体
                      textAlign:"center",//设置文本的水平对齐方式
                      textPosition:"bottom",//设置文本的垂直位置
                      textMargin:5,//设置条形码和文本之间的间距
                      fontSize:45,//设置文本的大小
                      background:"#fff",//设置条形码的背景
                      lineColor:"#000",//设置条和文本的颜色。
                      margin:10//设置条形码周围的空白边距
                  });

              }

              setTimeout(function() { //执行打印操作
                  _this.sureprint();
              },500);

          },200);
          

      },

      //确认打印
      sureprint() {
          //设置打印完成后回调页面
          this.$cookies.set('returnurlids','logisticsprint');
          //获取打印信息
          var div_print=document.getElementById('printContent'); 
          var newStr=div_print.innerHTML;
          document.body.innerHTML=newStr;
          window.print();	    
          location.reload();
      },

  },

}
</script>

</script>
<style type="text/css">
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 3% 1%}

.print-express-main-ZTO {margin:auto;overflow:hidden;}
.printcontentmodel {display:inline-block;width:100%;}
.express-ZTO-time {width:100%;font-size:13px;color:#000;border:none;text-align:left;line-height:14px;font-weight:100;margin:auto;}
.express-ZTO-img {width:100%;border-bottom:1px solid #000;text-align:center;line-height:21px;margin:0 auto}
.express-ZTO-img img {width:65%;margin-top:5px}
.express-ZTO-area {width:100%;margin:0 auto;}
.express-ZTO-area-left {float:left;display:flex;justify-content:left;align-items:center;height:30px;border-right:1px solid #000000;}
.express-ZTO-area-left span {font-size:15px;font-weight:550;}
.express-ZTO-area-code {width:100%;margin:0 auto;border-bottom:1px solid #000000;text-align:center;font-size:20px;font-weight:550;padding:5px 0;clear:both;}
.express-ZTO-sender {width:100%;margin:0 auto;border-bottom:1px solid #000;clear:both}
.express-ZTO-sender-left {width:20%;height:60px;float:left;display:flex;justify-content:center;align-items:center;}
.express-ZTO-sender-left span {font-size:12px;line-height:12px;padding:5px;border-radius:50%;color:#000;font-weight:550;border:2px solid #000;}
.express-ZTO-sender-right {width:80%;height:60px;float:left;}
.express-ZTO-sender-right-content {float:left;width:100%;font-size:12px;line-height:12px;font-weight:530}
.express-ZTO-reciever {width:100%;margin:0 auto;border-top:1px solid #000;clear:both;}
.express-ZTO-reciever-left {width:20%;height:45px;float:left;display:flex;justify-content:center;align-items:center;}
.express-ZTO-reciever-left span {font-size:12px;line-height:12px;border-radius:50%;color:#000;font-weight:550;border:2px solid #000;}
.express-ZTO-reciever-right {width:80%;height:45px;float:left;}
.express-ZTO-reciever-right-content {float:left;width:100%;font-size:12px;line-height:12px;font-weight:530;}
.express-ZTO-bottom {width:100%;margin:0 auto;border-top:1px solid #000;clear:both;}
.express-ZTO-bottom-left {float:left;width:30%;height:40px;border-right:1px solid #000;display:flex;justify-content:center;align-items:center;}
.express-ZTO-bottom-left span {font-size:16px;font-weight:550;}
.express-ZTO-bottom-right {float:left;width:calc(70% - 1px);height:40px;display:flex;justify-content:center;align-items:center;}
.express-ZTO-bottom-right img  {max-width:80%}
.express-ZTO-sell {width:100%;margin:0 auto;border-top:1px solid #000;clear:both;font-size:12px;line-height:12px;padding-top:2px;font-weight:530}
</style>


// WEBPACK FOOTER //
// src/components/home/print/ZTO_model1.vue